import { render, staticRenderFns } from "./MainValues.vue?vue&type=template&id=1aba1696&scoped=true&"
import script from "./MainValues.vue?vue&type=script&lang=js&"
export * from "./MainValues.vue?vue&type=script&lang=js&"
import style0 from "./MainValues.vue?vue&type=style&index=0&id=1aba1696&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba1696",
  null
  
)

export default component.exports